import {createReducer} from '@reduxjs/toolkit'
import {RsvpStatus} from '@wix/events-types'
import {changeResponse, editRsvpStep, nextStep, setRsvpDetails} from '../actions/rsvp'
import {RSVP_STEPS} from '../constants/constants'
import {RsvpState} from '../types/state'

const defaultState: RsvpState = {
  currentStep: RSVP_STEPS[0],
  rsvpDetails: null,
  response: RsvpStatus.YES,
}

export const rsvp = createReducer(defaultState, builder => {
  builder
    .addCase(setRsvpDetails, (state, action) => {
      state.rsvpDetails = action.payload
    })
    .addCase(nextStep.fulfilled, (state, action) => {
      state.currentStep = action.payload.nextStep
    })
    .addCase(editRsvpStep, (state, action) => {
      state.currentStep = action.payload
    })
    .addCase(changeResponse, (state, action) => {
      state.response = action.payload
    })
})
